import { render, staticRenderFns } from "./AddEditLeadsHandlerDialog.vue?vue&type=template&id=20d4c56e&scoped=true&"
import script from "./AddEditLeadsHandlerDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditLeadsHandlerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditLeadsHandlerDialog.vue?vue&type=style&index=0&id=20d4c56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4c56e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d4c56e')) {
      api.createRecord('20d4c56e', component.options)
    } else {
      api.reload('20d4c56e', component.options)
    }
    module.hot.accept("./AddEditLeadsHandlerDialog.vue?vue&type=template&id=20d4c56e&scoped=true&", function () {
      api.rerender('20d4c56e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads-handlers-access/AddEditLeadsHandlerDialog.vue"
export default component.exports